/**
 * March Agent SDK - API Paths Configuration
 * 
 * Centralized configuration for all API endpoint paths.
 * This allows easy configuration if API versions or paths change.
 */

/**
 * API paths for AI Inventory service.
 */
export const AI_INVENTORY_PATHS = {
    /** Register a new agent */
    AGENT_REGISTER: '/api/v1/agents/register',
    /** Send heartbeat */
    HEALTH_HEARTBEAT: '/api/v1/health/heartbeat',
} as const

/**
 * API paths for Conversation Store service.
 * Note: These paths don't have /api/v1/ prefix.
 */
export const CONVERSATION_STORE_PATHS = {
    /** Get/update conversation by ID */
    CONVERSATION: (conversationId: string) => `/conversations/${conversationId}`,
    /** Get messages for a conversation */
    CONVERSATION_MESSAGES: (conversationId: string) => `/conversations/${conversationId}/messages`,
    /** Checkpoints base path */
    CHECKPOINTS: '/checkpoints/',
    /** Checkpoint by thread ID */
    CHECKPOINT_THREAD: (threadId: string) => `/checkpoints/${threadId}`,
    /** Agent state by conversation ID */
    AGENT_STATE: (conversationId: string) => `/agent-state/${conversationId}`,
} as const

/**
 * API paths for AI Memory service.
 * Note: These paths don't have /api/v1/ prefix.
 */
export const MEMORY_PATHS = {
    /** User memory base */
    USER_MEMORY: (userId: string) => `/memory/${userId}`,
    /** Add messages to memory */
    USER_MESSAGES: (userId: string) => `/memory/${userId}/messages`,
    /** Search user memory */
    USER_SEARCH: (userId: string) => `/memory/${userId}/search`,
    /** Get user summary */
    USER_SUMMARY: (userId: string) => `/memory/${userId}/summary`,
} as const

/**
 * Service names for gateway proxy routing.
 */
export const SERVICES = {
    AI_INVENTORY: 'ai-inventory',
    CONVERSATION_STORE: 'conversation-store',
    AI_MEMORY: 'ai-memory',
    ATTACHMENT: 'attachment',
} as const

export type ServiceName = typeof SERVICES[keyof typeof SERVICES]
